<app-navtop></app-navtop>
<app-navside-apps-list></app-navside-apps-list>
<app-navside-sponsor></app-navside-sponsor>

<div class="container pt-5">
    <div class="d-flex flex-row bd-highlight my-2">
        <div class="col-lg-6 col-md-8 p-2 mx-xl-auto mx-lg-auto ml-md-auto content-main">
            <div class="list-group my-1" *ngFor="let item of territoryCol | async">
                <a class="list-group-item list-group-flush" (click)="routeToGovernmentDetailPage(item.name)" routerLink="">                
                    <div class="media">                        
                        <!-- <img *ngIf="!item.profilePicture" [src]="logoImage" class="mr-3 align-self-center rounded-circle image" alt="...">
                        <img *ngIf="item.profilePicture" [src]="item.profilePicture" class="mr-3 align-self-center rounded-circle image" alt="..."> -->
                        <div class="media-body">
                            <span class="h2">{{ item.name }}</span>
                        </div>
                    </div>                
                </a>   
            </div>
        </div>
    </div>
</div>
